import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { CSSProperties, useEffect, useState } from 'react';
import styled from 'styled-components';

import useLiveGameImage from '../../../hooks/useLiveGameImage';
import { Response } from '../../../services/backendService/types';
import { Center } from '../../_atoms/Center';

export const SmartVideo = ({
  imageId,
  isAuthenticated,
  tenantId,
  onClick,
  modifiedAt,
}: {
  tenantId: string;
  imageId: string;
  isAuthenticated: boolean;
  onClick: (data: string) => void;
  modifiedAt?: number;
}) => {
  const { imageUrl: src } = useLiveGameImage(
    tenantId,
    imageId,
    modifiedAt,
    isAuthenticated,
  );
  const [currentSrc, setCurrentSrc] = useState<string | undefined>();
  useEffect(() => {
    if (src) {
      setCurrentSrc(src);
    }
  }, [src]);
  if (!currentSrc)
    return (
      <Center style={{ width: '100', height: '100%', padding: '10px' }}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 16 }} spin />} />
      </Center>
    );

  return <VideoElement onClick={() => src && onClick(src)} src={src}></VideoElement>;
};

const VideoElement = styled.video`
  height: 100%;
  width: 100%;
  cursor: pointer;
`;

const LazyVideoResponse = ({
  onClick,
  response,
  tenantId,
  isAuthenticated,
}: {
  onClick?: (s: string) => void;
  response: Response;
  hide?: boolean;
  boxShadow?: string;
  style?: CSSProperties;
  tenantId: string;
  isAuthenticated: boolean;
}) => {
  if (!response.response) return null;
  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <SmartVideo
        onClick={data => onClick && onClick(data)}
        imageId={response.response}
        isAuthenticated={isAuthenticated}
        tenantId={tenantId}
        modifiedAt={response.modifiedAt}
      />
    </div>
  );
};
export default LazyVideoResponse;
